export const selectImgSrc = (state) => state.photo.imageSrc;

export const selectMergedImg = (state) => state.photo.mergedImage;

export const selectCoordinates = (state) => state.photo.coordinates;
